"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETHER_ADDRESS = void 0;
const ETHER_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
exports.ETHER_ADDRESS = ETHER_ADDRESS;
//# sourceMappingURL=types.js.map